import stores from "@/stores"
import { autoReplenishPoint } from "@/utils/formatNumber"
import { formatPriceByTemplate } from "@/utils/formatPriceByTemplate"
interface IFormatPriceTextProps {
  value: number | string
  formatType?: string
  currency?: string
  hideDecimalsWhenInteger?: boolean
}

const FormatPriceText = (props: IFormatPriceTextProps) => {
  const {
    value,
    formatType = stores.UserInfoStore.data.money_format,
    currency, // 有传currency参数，表示自定义展示的货币和值
    hideDecimalsWhenInteger = false,
  } = props
  return (
    <span>
      {currency ? (
        <span>{`${currency}${autoReplenishPoint(value, true, true, hideDecimalsWhenInteger)}`}</span>
      ) : (
        <span
          dangerouslySetInnerHTML={{
            __html: formatPriceByTemplate({
              value,
              formatType: formatType,
              hideDecimalsWhenInteger,
            }),
          }}
        ></span>
      )}
    </span>
  )
}

export default FormatPriceText
